import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";
const DEFAULT_SECONDARY_COLOR = "var(--label-tertiary)";

const ROTATE_VALUE_TOP_BOTTOM = 0;
const ROTATE_VALUE_RIGHT_LEFT = 90;

enum BorderTwoSide {
    TopBottom = "topBottom",
    RightLeft = "rightLeft"
}

interface Props extends IconProps {
    side?: BorderTwoSide;
}

function calculateRotationByPosition(side: BorderTwoSide): number {
    switch (side) {
        case BorderTwoSide.TopBottom:
            return ROTATE_VALUE_TOP_BOTTOM;
        case BorderTwoSide.RightLeft:
            return ROTATE_VALUE_RIGHT_LEFT;
        // no default
    }
}

function IconBorderTwoSidesAlignment({
    class: cssClass,
    color,
    secondaryColor,
    side = BorderTwoSide.TopBottom
}: Props) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;
    const secondaryFill = secondaryColor ?? `var(--icon-secondary-color, ${DEFAULT_SECONDARY_COLOR})`;
    const rotation = calculateRotationByPosition(side);

    return (
        <svg class={cssClass} width="12" height="12" viewBox="0 0 12 12" fill="none" style={{ transform: `rotate(${rotation}deg)` }} xmlns="http://www.w3.org/2000/svg">
            <path fill={secondaryFill} fill-rule="evenodd" d="M.5 1.75a.5.5 0 0 1 .5.5v7.5a.5.5 0 0 1-1 0v-7.5a.5.5 0 0 1 .5-.5zm11 0a.5.5 0 0 1 .5.5v7.5a.5.5 0 0 1-1 0v-7.5a.5.5 0 0 1 .5-.5z"/>
            <path fill={fill} fill-rule="evenodd" d="M1.25.5a.5.5 0 0 1 .5-.5h8.5a.5.5 0 0 1 0 1h-8.5a.5.5 0 0 1-.5-.5zM1.25 11.5a.5.5 0 0 1 .5-.5h8.5a.5.5 0 0 1 0 1h-8.5a.5.5 0 0 1-.5-.5z"/>
        </svg>
    );
}

export default IconBorderTwoSidesAlignment;
export { BorderTwoSide };
